import React, { Key } from 'react';
import { Form, FormInstance } from 'antd';

import { EPSelect, EPSelectOption } from '@/components';
import { useStores } from '@/hooks/use-stores';
import { getRolesByRowIndex } from '../UserCreateOrEditForm.utils';

interface RoleSelectCellProps {
  field: {
    name: string | number;
    fieldKey?: Key;
  };
  index: number;
  form: FormInstance;
  isDisabled: boolean;
  t: (key: string) => string;
}

const RoleSelectCell: React.FC<RoleSelectCellProps> = ({ field, index, form, isDisabled, t }) => {
  const { associableEntitiesStore } = useStores();
  return (
    <Form.Item
      {...field}
      name={[field.name, 'roleId']}
      key={[field.fieldKey, 'roleId'] as unknown as Key}
      rules={[{ required: true, message: t('Please choose a role') }]}
    >
      <EPSelect
        placeholder={t('Select role')}
        dropdownMatchSelectWidth={false}
        style={{ minWidth: 150 }}
        disabled={isDisabled}
      >
        {getRolesByRowIndex(index, form, associableEntitiesStore).map(role => (
          <EPSelectOption key={role.id} disabled={role.isInternal}>
            {role.name}
          </EPSelectOption>
        ))}
      </EPSelect>
    </Form.Item>
  );
};

export default RoleSelectCell;
